import { Fragment, useContext, useState } from "react";
import { ReactComponent as BlackVatugIcon } from "../../Asset/black.svg";
import { useNavigate } from "react-router-dom";
import useFormUploadOtherDocs_v from "../Libs/useVesselOwnerOtherDoc";
import { ToastContainer, toast } from "react-toastify";
import { AuthContext } from "../../Context/AuthContext";
import "./vesselagreesment.css"

const VesselAgreement = () => {
  const navigate = useNavigate();
  const { handleSkip: handleSkip_v, loading: loading_v,error, success } = useFormUploadOtherDocs_v();
  const [isChecked, setIsChecked] = useState(false);
  const { user } = useContext(AuthContext);

  const handleCheckboxChange = (e) => {
    setIsChecked(e.target.checked);
  };

  const handleNoClick = () => {
    
    if (!isChecked) {
      toast.warn("You must accept the agreement before proceeding.");
      return;
    }

    localStorage.removeItem("skipOverlay");
    if (user.role === "vesselOwner") {
      handleSkip_v();
      localStorage.removeItem("skipOverlay");
    }
  };

  return (
    <Fragment>
      <ToastContainer/>
    
    <div className="agrement-container">
        <div className="header">
          <button onClick={() => navigate("/updates")}>Back</button>
          <BlackVatugIcon onClick={() => navigate("/")}/>
          <button
          className="finished"
          onClick={handleNoClick}
          disabled={loading_v || !isChecked}  
        >
          {loading_v ? "Saving..." : "Finished"}
        </button>
        </div>
      <div className="content">
        <h1 className="title">Vessel Nomination Document</h1>

        <p className="intro">
          THIS VESSEL NOMINATION AGREEMENT is made this [0] [0], [0] between:
        </p>

        <ol className="list">
          <li>
            VATUG TECHNOLOGIES LIMITED. of [0] (hereinafter described as "Vatug Tech" which expression shall, where the context so admits, include its successors-in-title and assigns),
          </li>
          <p>AND</p>
          <li>
            YOU, (hereinafter described as "the Vessel Owner" which expression shall, where the context so admits, include your successors-in-title and assigns).
          </li>
        </ol>

        <h2 className="subheading">WHEREAS</h2>
        <ul className="unordered-list">
          <li>The Vessel Owner nominates its vessel for charter and/or sale.</li>
          <li>The Vessel Owner nominates Vatug Tech as its broker to charter and/or sell the vessel ("The Service").</li>
          <li>
            You agree that upon executing this Agreement, you subscribe to The Services and you agree to be bound by the terms of this Agreement.
          </li>
          <li>
            It is agreed that the terms of this Vessel Nomination Agreement shall form part of the Charter Brokerage Services Agreement.
          </li>
        </ul>

        <h2 className="subheading">STANDARD TERMS AND CONDITIONS</h2>
        <ol className="list">
          <li>
            Upon executing this Agreement, you authorize Vatug Tech to retain your data and contact you to discuss the terms of this Agreement. By signing this Agreement, you expressly consent to such retention and communication.
          </li>
          <li>
            You agree to execute all necessary agreements and documents required to give full effect to this Agreement.
          </li>
          <li>
            You agree to provide us with all documents and information necessary to complete our Know Your Customer (KYC) procedure.
          </li>
          <li>
            You consent to Vatug Tech being authorized to inspect the Vessel to confirm its condition and fitness for the intended purpose.
          </li>
          <li>
            Nothing in this Agreement shall be construed as creating a partnership, agency, or employment relationship between us and you, and neither shall have the right, power, or authority to create any obligation or duty, express or implied, on behalf of the other Party.
          </li>
          <li>
            If any provision of this Agreement is deemed void, invalid, or unenforceable, that provision shall be severed from the remainder of the Agreement. All remaining provisions of this Agreement shall then continue in full force.
          </li>
          <li>
            This Agreement shall be governed by, and construed in accordance with, the laws of the Federal Republic of Nigeria.
          </li>
          <li>
            If any dispute arises from or in connection with this Agreement, you agree to resolve it amicably within 21 calendar days. If we cannot resolve the conflict within this period, the dispute shall be referred to arbitration in accordance with the Arbitration and Mediation Act 2023.
          </li>
        </ol>

        <div className="checkbox-container">
          <input
            type="checkbox"
            id="accept"
            className="checkbox"
            required
            checked={isChecked}  
            onChange={handleCheckboxChange}  
          />
          <label htmlFor="accept" className="checkbox-label">
            I have read and accepted the vessel nomination agreement
          </label>
        </div>
          <button
          className="finished"
          onClick={handleNoClick}
          disabled={loading_v || !isChecked}  
        >
          {loading_v ? "Saving..." : "Finished"}
        </button>
          {error && <p style={{ color: "red", fontFamily:"Montserrat" }}>{error}</p>}
          {success && <p style={{ color: "green", fontFamily:"Montserrat" 
            
           }}>{success}</p>}
      </div>
    </div>
    </Fragment>
  )
};

export default VesselAgreement;